import { render } from "./Collection.vue?vue&type=template&id=68f3975b&scoped=true&ts=true"
import script from "./Collection.vue?vue&type=script&lang=ts"
export * from "./Collection.vue?vue&type=script&lang=ts"

import "./Collection.vue?vue&type=style&index=0&id=68f3975b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2791644585/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f3975b"]])

export default __exports__